/* istanbul ignore file */
export const IN_STOCK = Symbol("IN_STOCK");
export const LOW_IN_STOCK = Symbol("LOW_IN_STOCK");
export const OUT_OF_STOCK = Symbol("OUT_OF_STOCK");
export const COLOUR_OUT_OF_STOCK = Symbol("COLOUR_OUT_OF_STOCK");
export const SIZE_OUT_OF_STOCK = Symbol("SIZE_OUT_OF_STOCK");
export const COLOUR_OR_SIZE_OUT_OF_STOCK = Symbol(
  "COLOUR_OR_SIZE_OUT_OF_STOCK"
);
export const RESTOCKING_SOON = Symbol("RESTOCKING_SOON");
